import {
  hasInternalApi,
  internalApiDelete,
  internalApiGet,
  internalApiPost
} from './internalApi'

export interface RecorderTokenRow {
  id: string
  label: string | null
  last_used_at: string | null
  created_at: string
}

/**
 * Issue a fresh token for the current manager. Returns the plaintext
 * token (shown once) and the new row id. Stores only the sha256 hash
 * server-side, so this value cannot be retrieved later.
 */
export async function issueRecorderToken(args: {
  managerId: string
  label?: string | null
}): Promise<{ plaintext: string; row: RecorderTokenRow }> {
  ensureRecorderTokensInternalApi()
  const data = await internalApiPost<{
    plaintext: string
    token: RecorderTokenRow
  }>('/api/recorder-tokens', {
    label: args.label ?? null
  })
  return { plaintext: data.plaintext, row: data.token }
}

export async function listRecorderTokens(_managerId: string): Promise<RecorderTokenRow[]> {
  ensureRecorderTokensInternalApi()
  const data = await internalApiGet<{ tokens: RecorderTokenRow[] }>('/api/recorder-tokens')
  return data.tokens
}

export async function revokeRecorderToken(id: string): Promise<void> {
  ensureRecorderTokensInternalApi()
  await internalApiDelete<{ ok: true }>(`/api/recorder-tokens/${id}`)
}

function ensureRecorderTokensInternalApi(): void {
  if (!hasInternalApi()) {
    throw new Error(
      'Recorder tokens require the Internal API. Set VITE_LOGMANE_API_URL to enable /api/recorder-tokens.'
    )
  }
}
